import React from 'react';
import { formatDateOnly } from '../utils/dates';

/**
 * Empty prompt on a white field. Theme textMuted (#999) is about 2.8:1 there.
 * textSecondary (#666) is about 5.7:1. Dark surfaces keep textMuted.
 */
function emptyDateColor(colors) {
  const surface = String((colors && colors.surface) || '').replace(/\s/g, '').toLowerCase();
  const onWhite = surface === '#fff' || surface === '#ffffff' || surface === 'white';
  if (onWhite) return (colors && colors.textSecondary) || '#666666';
  return colors && colors.textMuted;
}

function CalendarIcon() {
  return (
    <svg aria-hidden="true" width="22" height="22" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
      <rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 3.5v3M16 3.5v3M3.5 10h17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

/**
 * A date control that stays readable when the native picker is empty.
 * The native input still opens the calendar.
 */
export default function PlanDateField({ id, value, onChange, colors, disabled, label }) {
  const filled = Boolean(value);
  const shown = filled
    ? formatDateOnly(value, 'en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    : 'Tap to pick a date';
  return (
    <div style={{ position: 'relative', marginBottom: '0.75rem' }}>
      <div
        aria-hidden="true"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '0.75rem',
          minHeight: '48px',
          padding: '0.75rem 1rem',
          borderRadius: '0.75rem',
          border: `1px solid ${colors.border}`,
          background: colors.surface,
          color: filled ? colors.text : emptyDateColor(colors),
          fontSize: '1rem',
          boxSizing: 'border-box',
        }}
      >
        <span>{shown}</span>
        <CalendarIcon />
      </div>
      <input
        id={id}
        type="date"
        value={value || ''}
        disabled={disabled}
        aria-label={label || 'Tap to pick a date'}
        onChange={onChange}
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          opacity: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
          fontSize: '1rem',
        }}
      />
    </div>
  );
}
